import { getV3RouterContract } from '../../../../getContract';
import { getV3SwapCallParamsFromTrade } from './getV3SwapCallParamsFromTrade';
/**
 * Returns the swap calls that can be used to make the trade on V3 protocol
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName the ENS name or address of the recipient of the swap output
 * @param signatureData the signature data of the permit of the input token amount, if available
 */
export function getSwapCallV3Params(_a) {
    var library = _a.library, account = _a.account, chainId = _a.chainId, trade = _a.trade, allowedSlippage = _a.allowedSlippage, deadline = _a.deadline;
    var recipient = account;
    var routerContract = getV3RouterContract(library, account, chainId);
    if (!trade || !recipient || !library || !account || !chainId || !deadline)
        return undefined;
    if (!routerContract)
        return undefined;
    var params = getV3SwapCallParamsFromTrade(trade, {
        feeOnTransfer: false,
        allowedSlippage: allowedSlippage,
        recipient: recipient,
        deadline: deadline.toNumber(),
    });
    return {
        address: routerContract.address,
        params: params.params,
        value: params.value,
    };
}
